<template lang="pug">
  .reservation
    sys-bar(:backable="true" ref="sysBar")
    .content(ref="content")
      transition-slide
        router-view
</template>

<script>
import SysBar from '@/components/SysBar'
import { mapState, mapMutations } from 'vuex'
import TransitionSlide from '@/components/TransitionSlide'
import AlipayService from '@/services/AlipayService'
export default {
  name: 'Reservation',
  components: { TransitionSlide, SysBar },
  data() {
    return {
      pending: true,
      getPhoneNumberRequesting: false
    }
  },
  computed: {
    ...mapState('app', ['router', 'user']),
  },
  methods: {
    ...mapMutations('app', ['setRouterBack', 'setPending']),
    onAbort() {
      console.log('abort')
      this.pending = false
      this.setPending(false)
      this.getPhoneNumberRequesting = false
      this.$router.replace('/')
    },
    onMessage(e) {
      //let isGetPhoneNumberComplete = localStorage.getItem("getPhoneNumberComplete")
      let isGetPhoneNumberComplete = (e.data.user.phoneNumberStatus===1)
      if (e.msg === AlipayService.Events.USER_INFO_UPDATE) {
        if (!isGetPhoneNumberComplete) {
          this.getPhoneNumberRequesting = true
          AlipayService.sendEvent(AlipayService.Events.GET_PHONE_NUMBER_REQUEST)
          AlipayService.on(AlipayService.Events.ONMESSAGE, vm.onMessage)
        } else if (e.data.user.userType === 0) {
          this.pending = false
          this.setPending(false)
          this.$router.replace('/reservation/res1')
        }
      }
      if (e.msg === AlipayService.Events.USER_AUTH_ABORT) {
        this.onAbort()
      }
      if (e.msg === AlipayService.Events.GET_PHONE_NUMBER_FAIL) {
        this.onAbort()
      }
      if (e.msg === AlipayService.Events.GET_PHONE_NUMBER_COMPLETE) {
          localStorage.setItem('getPhoneNumberComplete', '1')
          this.pending = false
          this.setPending(false)
          this.getPhoneNumberRequesting = false
          this.$router.replace('/reservation/res1')
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    if (to.path === '/reservation') {
      console.log(to, from)
      //let isGetPhoneNumberComplete = localStorage.getItem("getPhoneNumberComplete")
      next((vm) => {
        let isGetPhoneNumberComplete = (vm.$store.state.app.user.phoneNumberStatus===1)
        console.log(999, vm)
        if (vm.$store.state.app.user.userType !== 0) {
          //console.log(vm)
          AlipayService.sendEvent(AlipayService.Events.USER_AUTH_REQUEST)
          AlipayService.on(AlipayService.Events.ONMESSAGE, vm.onMessage)
          vm.setPending(true)
        } else if(!isGetPhoneNumberComplete) {
          if(vm.getPhoneNumberRequesting){
            vm.onAbort()
          } else {
            vm.getPhoneNumberRequesting = true
            AlipayService.sendEvent(AlipayService.Events.GET_PHONE_NUMBER_REQUEST)
            AlipayService.on(AlipayService.Events.ONMESSAGE, vm.onMessage)
            vm.setPending(true)
          }
        }
        else {
          vm.$router.replace('/reservation/res1')
        }
      })
    } else {
      next()
    }
  },
  beforeRouteLeave(to, from, next) {
    AlipayService.off(AlipayService.Events.ONMESSAGE, this.onMessage)
    next()
  },
  watch: {
    // user: {
    //   deep: true,
    //   handler(val) {
    //     if (this.pending && val.userType === 0) {
    //       this.pending = false
    //       this.setPending(false)
    //       this.$router.replace('/reservation/res1')
    //     }
    //   },
    // },
    $route(val) {
      console.log(val)
      console.log('this section has been run')
      if (val.path === '/reservation/res1') this.setRouterBack('/')
      if (val.path === '/reservation/res2')
        this.setRouterBack('/reservation/res1')
      if (val.path === '/reservation/res3')
        this.setRouterBack('/reservation/res2')
    },
  },
  mounted() {
    this.$refs.content.style.height =
      window.innerHeight -
      this.$refs.sysBar.$el.getBoundingClientRect().height +
      'px'

    // if (this.pending) {
    //   AlipayService.sendEvent(AlipayService.Events.USER_AUTH_REQUEST)
    //   AlipayService.on(AlipayService.Events.USER_AUTH_ABORT, this.onAbort)
    //   this.setPending(true)
    // }
  },
}
</script>

<style scoped lang="sass">
@import "../../styles/common"
.reservation
  .content
    position: relative

.slide-enter, .slide-leave-to
  transform: translateX(100%)
</style>
